/* eslint-disable import/order */
/* eslint-disable import/first */
import Vue from 'vue';
import Axios from 'axios';
import ServerUtils from './services/ServerUtils';
import 'array-flat-polyfill';

window.Vue = Vue;
window.axios = Axios;

import vuetify from 'vuetify';

Vue.use(vuetify);
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueSweetAlert2 from 'vue-sweetalert2';
import VueSocialSharing from 'vue-social-sharing';
import VueGtag from 'vue-gtag';
import { createVPhoneInput } from 'v-phone-input';
import _ from 'lodash';
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import 'v-phone-input/dist/v-phone-input.css';
import 'flag-icons/css/flag-icons.min.css';

Vue.use(VueSweetAlert2, {
    confirmButtonColor: '#181235',
    cancelButtonColor: '#d32f2f',
    reverseButtons: true,
});

Vue.use(require('vue-moment'));

Vue.use(VueSocialSharing);

Vue.use(Vuex);
Vue.use(Api);
Vue.use(VueRouter);

const vPhoneInput = createVPhoneInput({
    countryIconMode: 'svg',
});

Vue.use(vPhoneInput);

import _validationRules from './modules/validationRules';

import kaoshiButton from './components/kaoshi-button/kaoshi-button.vue';
import loadingOverlay from './components/loading-overlay.vue';
import userFeedback from './components/user-feedback.vue';

import store from './store';
import Api from './services/api';
import appComponent from './views/app/app.vue';
import appMobileMenu from './views/app/mobile-menu.vue';
import appHeader from './views/app/header.vue';
import appMenu from './views/app/menu.vue';
import login from './views/login.vue';
import tfaConfirm from './views/tfa-confirm.vue';
import signUp from './views/sign-up.vue';
import offersList from './views/transfers/list.vue';
import offersCreate from './views/transfers/create.vue';
import formatCurrency from './modules/formatCurrency';
import formatInteger from './modules/formatInteger';
import positionBottomButton from './modules/positionBottomButton';
import userMixins from './mixins/user.mixin';
import global from './mixins/global';

import paymentMixins from './mixins/payment.mixins';
import TextHighlight from 'vue-text-highlight';

Vue.component('text-highlight', TextHighlight);

import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';

Vue.component('DynamicScroller', DynamicScroller);
Vue.component('DynamicScrollerItem', DynamicScrollerItem);

import router from './router';

if (ServerUtils.isProduction()) {
    const kaoshiMoney = JSON.parse(localStorage.getItem('kaoshi-money'));
    const userId = _.get(kaoshiMoney, 'user.id');
    Vue.use(VueGtag, {
        config: {
            id: 'G-H9SY4JEE98',
            params: {
                user_id: userId,
            },
        },
    }, router);
}

Vue.component('app-mobile-menu', appMobileMenu);
Vue.component('app-header', appHeader);
Vue.component('app-menu', appMenu);
Vue.component('app-login', login);
Vue.component('tfa-confirm', tfaConfirm);
Vue.component('sign-up', signUp);
Vue.component('kaoshi-button', kaoshiButton);
Vue.component('offers-create', offersCreate);
Vue.component('offers-list', offersList);
Vue.component('loading-overlay', loadingOverlay);

Vue.component('user-feedback', userFeedback);
Vue.mixin(userMixins);
Vue.mixin(paymentMixins);
Vue.mixin(global);

Vue.filter('currency', formatCurrency);
Vue.filter('integer', formatInteger);

Vue.filter('capitalize', (value) => {
    if (!value) return '';
    const val = value.toString();
    return val.charAt(0).toUpperCase() + val.slice(1);
});
Vue.filter('datetime', (value) => Vue.moment(value).format('L, h:mm:ss A'));
Vue.filter('date', (value) => Vue.moment(value).format('L'));

Vue.mixin({
    methods: {
        positionBottomButton,
    },
});

Object.defineProperty(Vue.prototype, '_', { value: _ });

const app = new Vue({
    components: { appComponent },
    router,
    store,
    // eslint-disable-next-line new-cap
    vuetify: new vuetify({
        icons: {
            iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
        },
        theme: {
            options: {
                customProperties: true,
            },
            themes: {
                light: {
                    primary: '#181235',
                    secondary: '#49e2b5',
                },
            },
        },
    }),
    created: () => {
        store.commit('clearLogoPartClass', '');
    },
});

app.$mount('#app');

export default app;
